import { useCallback, useState } from 'react';
import * as S from './styles';

interface ExpandCardProps {
  title: string | React.ReactNode;
  description: React.ReactNode;
  id?: number;
  defaultOpen?: boolean;
  canOpen?:boolean;
}

// 확장 상태를 유지해달라는 피드백을 받아서 기본값을 true로 설정 및 Click 이벤트 제거
const ExpandCard = ({ title, description, id, defaultOpen = false, canOpen = false }: ExpandCardProps) => {
  const [isExpanded, setIsExpanded] = useState(!canOpen ? true : false);

  const handleExpandToggle = useCallback(() => {
    if(!canOpen) return;
    setIsExpanded((prev) => !prev);
  }, [canOpen]);

  return (
    <S.ItemWrapper
      className={isExpanded ? 'expanded' : ''}
      onClick={handleExpandToggle}
    >
      <S.ItemHeader className={isExpanded ? 'expanded' : ''}>
        {title}

        {canOpen && <S.IconWrapper size={24}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10L12 15"
              stroke={isExpanded ? '#0D1117' : 'white'}
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 15L17 10"
              stroke={isExpanded ? '#0D1117' : 'white'}
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </S.IconWrapper>}
      </S.ItemHeader>

      <S.ItemContent isExpanded={isExpanded}>{description}</S.ItemContent>
    </S.ItemWrapper>
  );
};

export default ExpandCard;
